export default {"src":"/_next/static/media/kenya.9a1ec98b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};